var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"title"},[_vm._v("Diagnose")]),_vm._v(" "),(_vm.diagnose && _vm.diagnose.object)?_c('div',[_c('div',{staticClass:"ui segment"},[_vm._v("\n      "+_vm._s(_vm.diagnose.object.diagnose_text)+"\n    ")])]):_c('p',[_vm._v("No diagnose")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269ff2f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/patients/patient_log_componenets/visit_history_components/Diagnose.vue
// module id = null
// module chunks = 